import React, { useMemo } from "react";
import HomeLanding from "../HomeLanding/HomeLanding";
import { defaultHomeLandingModel } from "../HomeLanding/defaultHomeLandingModel";
import type { ReleaseCardModel } from "../HomeLanding/HomeLandingModel";
import { useRealCatalog } from "../../hooks/useRealCatalog";


const UserHome: React.FC = () => {
  const { entries } = useRealCatalog();

  const newestReleases = useMemo<ReleaseCardModel[]>(
    () =>
      entries.slice(0, 6).map((entry) => ({
        id: entry.asset.id,
        title: entry.asset.title,
        description: entry.asset.description,
        price: entry.asset.price,
        role: "CREATOR",
        thumbnailSrc: entry.asset.thumbnailUrl,
        picks: [
          { label: "Category", value: entry.category || "-" },
          { label: "Format", value: entry.asset.tags || "-" },
          { label: "Duration", value: entry.asset.duration || "-" },
        ],
      })),
    [entries]
  );

  const model = useMemo(
    () => ({
      ...defaultHomeLandingModel,
      newestReleases,
    }),
    [newestReleases]
  );

  return <HomeLanding model={model} />;
};

export default UserHome;

